import { TrendingUp, TrendingDown } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

interface StatsCardProps {
  title: string
  value: string | number
  icon: LucideIcon
  trend?: 'up' | 'down' | 'neutral'
  trendValue?: string
  color?: 'green' | 'blue' | 'orange' | 'purple' | 'red' | 'teal'
  subtitle?: string
}

const COLOR_MAP = {
  green: {
    bg: 'bg-primary-50',
    iconBg: 'bg-primary-600',
    text: 'text-primary-600',
  },
  blue: {
    bg: 'bg-blue-50',
    iconBg: 'bg-blue-500',
    text: 'text-blue-600',
  },
  orange: {
    bg: 'bg-orange-50',
    iconBg: 'bg-accent',
    text: 'text-accent',
  },
  purple: {
    bg: 'bg-purple-50',
    iconBg: 'bg-purple-500',
    text: 'text-purple-600',
  },
  red: {
    bg: 'bg-red-50',
    iconBg: 'bg-red-500',
    text: 'text-red-600',
  },
  teal: {
    bg: 'bg-teal-50',
    iconBg: 'bg-teal-500',
    text: 'text-teal-600',
  },
}

export default function StatsCard({
  title,
  value,
  icon: Icon,
  trend,
  trendValue,
  color = 'green',
  subtitle,
}: StatsCardProps) {
  const colors = COLOR_MAP[color]

  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-[#6B7280] uppercase tracking-wide truncate">{title}</p>
          <p className="mt-1.5 text-2xl font-bold text-[#1A1A2E] leading-tight">{value}</p>
          {subtitle && (
            <p className="mt-0.5 text-xs text-[#6B7280]">{subtitle}</p>
          )}
          {trend && trendValue && (
            <div className="flex items-center gap-1 mt-2">
              {trend === 'up' ? (
                <TrendingUp className="w-3.5 h-3.5 text-emerald-500" />
              ) : trend === 'down' ? (
                <TrendingDown className="w-3.5 h-3.5 text-red-500" />
              ) : null}
              <span
                className={`text-xs font-semibold ${
                  trend === 'up'
                    ? 'text-emerald-600'
                    : trend === 'down'
                    ? 'text-red-500'
                    : 'text-[#6B7280]'
                }`}
              >
                {trendValue}
              </span>
              <span className="text-xs text-[#6B7280]">vs last month</span>
            </div>
          )}
        </div>
        <div className={`w-11 h-11 rounded-xl ${colors.iconBg} flex items-center justify-center flex-shrink-0 ml-3`}>
          <Icon className="w-5 h-5 text-white" />
        </div>
      </div>
    </div>
  )
}
